"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var typestyle_1 = require("typestyle");
var SvgFieldIcon_1 = require("../field/components/SvgFieldIcon");
var FieldFunctions_1 = require("../field/functions/FieldFunctions");
var FieldNameMapping_1 = require("../field/functions/FieldNameMapping");
var LayoutComponents_1 = require("../style/LayoutComponents");
var LayoutStyles_1 = require("../style/LayoutStyles");
var ViewerPaneLayoutComponents_1 = require("./ViewerPaneLayoutComponents");
var ViewerPaneStyles_1 = require("./ViewerPaneStyles");
var VizClientFieldCard_1 = require("./VizClientFieldCard");
var FieldIconHeight = 17;
// this is a workaround since the shared widgets expando doesn't have a prop that allows us to right
// align the carat, note that this breaks the contract with shared widgets, so if a bug occurs as a
// result of the widget being updated, its on us to fix it
var expandoCaratRightAlignedStyle = {
    $nest: {
        '& > [role="button"]': {
            width: '100%'
        },
        '& > [role="button"] > div': {
            flexGrow: 1
        },
        '& > [role="button"] > img': {
            order: 1
        },
    },
};
var FieldLabel = LayoutComponents_1.divWithStyle('VizClientFieldLabel', __assign(__assign({}, LayoutStyles_1.elideTextStyle), { maxWidth: 225 // TODO: try to remove hardcoded width (makes eliding work)
 }));
var FieldWrapper = LayoutComponents_1.divWithStyle('VizClientFieldWrapper', {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
});
var FieldCardFieldIcon = LayoutComponents_1.divWithStyle('VizClientFieldCardFieldIcon', {
    flexShrink: 0,
    height: FieldIconHeight,
});
var VizClientFieldElement = /** @class */ (function (_super) {
    __extends(VizClientFieldElement, _super);
    function VizClientFieldElement(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { expanded: false };
        return _this;
    }
    VizClientFieldElement.prototype.renderIconWithFieldName = function () {
        var fieldIcon = FieldFunctions_1.iconForField(this.props.field);
        return (React.createElement(FieldWrapper, null,
            React.createElement(FieldCardFieldIcon, { title: fieldIcon ? FieldNameMapping_1.FieldNameMappings[fieldIcon]() : '' },
                React.createElement(SvgFieldIcon_1.SvgFieldIcon, { fieldIcon: fieldIcon })),
            React.createElement(FieldLabel, null, this.props.field.name)));
    };
    VizClientFieldElement.prototype.render = function () {
        var _this = this;
        var isObfuscated = this.props.field.name === null;
        // the expando widget always will render its children, and hide it with 'display: hidden',
        // because of that its important that we make this check when rendering its children, otherwise
        // we may end up issuing way too many graphql requests up front, since some of the fields have
        // card content that issues its own graphql query
        var shouldRenderVizClientFieldCard = this.state.expanded;
        return (React.createElement(ViewerPaneStyles_1.SheetFieldListElementContainer, { "data-tb-test-id": 'data-details-field-element-container' }, isObfuscated ? ViewerPaneLayoutComponents_1.ViewerPaneObfuscatedPlaceholder() :
            React.createElement(widgets_1.ExpandoWidget, { className: typestyle_1.style(expandoCaratRightAlignedStyle), direction: widgets_1.ExpandoDirection.Down, isExpanded: this.state.expanded, onCollapse: function () { return _this.setState({ expanded: false }); }, onExpand: function () { return _this.setState({ expanded: true }); }, testId: 'data-details-field-element-expando', style: { display: 'block' }, label: this.renderIconWithFieldName() }, shouldRenderVizClientFieldCard ? (React.createElement(VizClientFieldCard_1.VizClientFieldCard, { field: this.props.field, workbookVizportalUrlId: this.props.workbookVizportalUrlId })) : null)));
    };
    return VizClientFieldElement;
}(React.Component));
exports.VizClientFieldElement = VizClientFieldElement;
//# sourceMappingURL=VizClientFieldElement.js.map